export default class SampleBill{
    constructor(tests, category, promo = null, billingData = null){
        this.tests = tests;
        this.category  = category;
        this.promo = promo;
        this.billingData = billingData
    }

    testPrice(test, category){
        let price = {
            price: 0,
            can_bundle: category !== "ISL",
            bundle_price: null,
            type: test.test_type.name,
            typeDesc: test.test_type.description,
            groupedDiscount: 0,
            detailedDiscount: null,
            discountApply: false
        };
        switch(test.test_type.name){
            case "P":
                    price.price = 50
                break;
            case "M":
                price.price = 50;
                break;
            case "A":
                if(this.tests.some(v => v.test_type.name === "M")){
                    price.can_bundle = false;
                    price.groupedDiscount = 50;
                    price.detailedDiscount = "-$50(micro grouped)"
                }
                    price.price = 50;
                break;
            case "Y":
                price.price = 50;
                break;
            case "T":
                price.price = 50;
                break;
            case "R":
                price.price = 50;
                break;
            case "Q":
                price.can_bundle = false;
                price.price = 120;
                price.groupedDiscount = 50;
                price.detailedDiscount = "-$50 for >= 3 standard tests"
                break;
            case "O":
                price.price = 100;
                price.can_bundle = false;
                break;
            case "L":
                price.price = 10;
                price.groupedDiscount = 10;
                price.detailedDiscount = "-10$ WA customer";
                price.can_bundle = false;
                break;
            case "F":
                price.price = 10;
                price.groupedDiscount = 10;
                price.detailedDiscount = "-10$ WA customer";
                price.can_bundle = false;
                break
            case "HM":
                price.can_bundle = false;
                price.price = 120;
                break
        }

        return price;
    }
// isls dont get bundle discount;
    calculateDiscountAndTotals(){
        let totals = [];
        let testCount = 0;
        let discountTotal = 0;
        let tests = this.tests;
        for(let i in tests) {
            let cost = this.testPrice(tests[i], this.category);
            totals.push(cost);
            if (cost.can_bundle) testCount += 1;
        }
        if(testCount === 2){
            discountTotal += 10;
        }else if(testCount === 3){
            discountTotal += 30;
        }else if(testCount === 4){
            discountTotal += 60;
        }else if(testCount === 5){
            discountTotal += 90;
        }else if(testCount > 5){
            discountTotal += 100;
        }

        return {
            discount: discountTotal,
            testCount: testCount,
            testPrices: totals,
        }
    }
    customDiscount(total, discount){
        let discountDecimal = discount/100;
        return total * discountDecimal;
    }
    getTotal(){
        let total = 0;
        let receipt = this.calculateDiscountAndTotals();
        let additions = null;
        receipt.testPrices.forEach(test => {
            if(test.bundle_price){
                total+=test.bundle_price;
            }else{
                total+=test.price;
            }
            if(test.type === "Q"){
                if(receipt.testCount >= 3){
                    total = total - test.groupedDiscount;
                    test.discountApply = true;
                }
            }else{
                total = total - test.groupedDiscount;
                test.discountApply = true;
            }
        });
        let finalTally = total - receipt.discount;
        let promotional = null;
        //Logic for removing hm test price from the final tally to convert discounts
        let subtractHmPrice = 0
        if(receipt.testPrices.some(test => test.type === "HM")){
            subtractHmPrice = receipt.testPrices.filter(test => test.type === "HM").length * 120;
            finalTally -= subtractHmPrice;
        }
        if(this.promo === "TWC" && receipt.testCount >= 3){
            if(finalTally < 210 && finalTally > 140){
                promotional = {discount: finalTally - 140, name: "TWC"};
                finalTally = 140;
            }else if(finalTally >= 210){
                finalTally -= 70
                promotional = {discount: 70, name: "TWC"};
            }
            
        }else if(this.promo === "PC" && receipt.testCount >=3){
            if(finalTally < 210 && finalTally > 160){
                promotional = {discount: finalTally - 160, name: "Pesticide Conscious"};
                finalTally = 160;
            }else if(finalTally >= 210){
                finalTally -= 50
                promotional = {discount: 50, name: "Pesticide Conscious"};
            }
        }
        if(this.category === "ISL"){
            additions = [];
            additions.push({name: "ISL", price: 35})
            finalTally += 35;
        }
        //re-apply hm price (0 if there wasnt hm)
        finalTally += subtractHmPrice;
        let discount = (this.billingData && this.billingData.discount > 0) ? this.customDiscount(finalTally, this.billingData.discount) : 0;
        finalTally -= discount;
        return {
            baseCost: total,
            customDiscount: {percent: this.billingData.discount, total: discount},
            promotional: promotional,
            additions: additions,
            totalCost: finalTally,
            ...receipt,
        }
    }
}
